import { useQueryClient } from "@tanstack/react-query";
import type { FC } from "react";
import CloudIcon from "../../../assets/Icon-Red_Hat-Cloud-A-Red-RGB.png";
import type { IPartnershipStatus } from "../../../constants/apiconstants-pfs";
import type { DragHandleProps } from "../../../constants/CardsStructure";
import Env from "../../../utils/env";
import { DashboardCard } from "../shared/DashboardCard";

export const CloudCard: FC<{ dragHandleProps?: DragHandleProps | undefined }> = ({ dragHandleProps }) => {
	const queryClient = useQueryClient();
	const partnershipStatus = queryClient.getQueryState(["partnershipStatus"])?.data as IPartnershipStatus;
	if (!partnershipStatus?.cloudPartner) return null;
	return (
		<DashboardCard
			icon={CloudIcon}
			title="Cloud certification"
			description="Access tools to certify your cloud images on Red Hat platforms and your cloud instances with Red Hat platforms"
			footerLinks={[
				{
					label: "View certification cases",
					href: `${Env.RHCERTURLs[Env.getEnvName()]}certifications#/?ecosystem=cloud`,
				},
				{ label: "Create new certification case", href: `${Env.RHCERTURLs[Env.getEnvName()]}?source=external` },
			]}
			dragHandleProps={dragHandleProps}
		/>
	);
};
